
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SearchIcon from "../../assets/images/search2.svg";
import { useRecoilValue } from "recoil";
import { atom_tourState } from "@app/shared/state/tour.atom";
import { useTranslation } from "react-i18next";

export const SearchSection: React.FC = () => {
  const tour = useRecoilValue(atom_tourState);
  const { t } = useTranslation();
  return (
    <Box 
      component="section" 
      sx={{ 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        gap: 2, 
        bgcolor: "white", 
        p: 3, 
        borderRadius: "20px 20px 0 0" 
      }}
    >
      <img src={SearchIcon} alt="Search" />
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, textAlign: "center" }}>
        <Typography variant="h5" sx={{ lineHeight: "30px" }}>
          {t('new_app.smart_guide_title')}
        </Typography>
        <Typography variant="body1">
          {t('new_app.smart_guide_subtitle', { title: tour?.title })}
        </Typography>
      </Box>
    </Box>
  );
};